require('../../libs/plugins/owl.carousel');

$(document).ready(function () {
    console.log('[Owl Carousel Generic] DOM ready, searching for owl-carousel elements...');
    console.log('[Owl Carousel Generic] Found', $('.owl-carousel').length, 'owl-carousel elements');

    $('.owl-carousel').each(function() {
        const items = 6; // Default number of items

        // Handle Criteo carousel specially - skip it here
        if (this.id === "criteo-owl") {
            console.log('[Owl Carousel Generic] Skipping Criteo carousel - handled by specialized module');
            return;
        }

        console.log(`[Owl Carousel Generic] Initializing generic carousel with ${items} items for:`, this.className);

        $(this).owlCarousel({
            stagePadding: 500,
            items: items,
            loop: false,
            navigation: true,
            addClassActive: true,
            afterInit: SetOwlCarouselFirstLast,
            afterAction: SetOwlCarouselFirstLast,
            autoPlay: 10000,
            itemsDesktop: [1199, Math.min(items, 3)],
            itemsDesktopSmall: [979, Math.min(items, 2)],
            itemsTablet: [768, Math.min(items, 2)],
            itemsTabletSmall: [480, 1],
            itemsMobile: [360, 1],
        });
    });

    function SetOwlCarouselFirstLast(el) {
        el.find(".owl-item").removeClass("first");
        el.find(".owl-item.active").first().addClass("first");
        el.find(".owl-item").removeClass("last");
        el.find(".owl-item.active").last().addClass("last");
    }
});